import React from 'react'
import Hero from '../components/Home/Hero'
import About from '../components/Home/About'
import Slider from '../components/Home/Slider'
import RecentWork from '../components/Home/RecentWork'
import Services from '../components/Home/Services'
import Skills from '../components/Home/Skills'
import Testimonials from '../components/Home/Testimonials'
import Contact from '../components/Home/Contact'

const Home = () => {
  return (
    <div>
      <Hero/>
      <Slider/>
      <About/>
      <RecentWork/>
      <Services/>
      <Skills/>
      <Testimonials/>
      <Contact/>
    </div>
  )
}

export default Home
